import constants from "../constants";
import { api } from "../services/api";
import { readVideo } from "./readVideo";

/** What a background video may be: the API refuses a bigger file too. */
export const BACKGROUND_VIDEO = {
  types: ["video/mp4", "video/webm"],
  maxBytes: 10 * 1024 * 1024,
  maxSeconds: 15,
};

/** Why a video can't be the background: not MP4/WebM, too big, too long, or the browser can't read it. */
export class BackgroundVideoError extends Error {
  constructor(readonly reason: "type" | "size" | "duration" | "unreadable") {
    super(reason);
  }
}

const send = async (siteId: string, file: Blob, size?: number) => {
  const authorization = await api.authorizeUpload(siteId, file.type, size);
  await api.upload(authorization, file, file.type);
  return `${constants.staticBucket}/${authorization.id}`;
};

/** Checks the video, then sends it and a frame of it (its poster) to the bucket. */
export const uploadBackgroundVideo = async (file: File, siteId: string) => {
  if (!BACKGROUND_VIDEO.types.includes(file.type)) {
    throw new BackgroundVideoError("type");
  }
  if (file.size > BACKGROUND_VIDEO.maxBytes) {
    throw new BackgroundVideoError("size");
  }
  const { duration, poster } = await readVideo(file).catch(() => {
    throw new BackgroundVideoError("unreadable");
  });
  // A little over the limit is still "15 seconds" to whoever recorded it
  if (duration > BACKGROUND_VIDEO.maxSeconds + 0.5) {
    throw new BackgroundVideoError("duration");
  }
  // the poster first: if it fails, no big file is left behind unused
  const posterUrl = await send(siteId, poster);
  return { url: await send(siteId, file, file.size), poster: posterUrl };
};
